module.exports = __webpack_public_path__ + "assets/SquareInCircleDetailed.5505c8e87f332ba524d6772f9c9330dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/SquareInCircleDetailed.png
// module id = 568
// module chunks = 0